<script setup>
import AnnouncementBar from "@/components/layout/AnnouncementBar.vue";
import SiteHeader from "@/components/layout/SiteHeader.vue";
import AppFooter from "@/components/layout/AppFooter.vue";
</script>

<template>
  <AnnouncementBar />
  <SiteHeader />
  <main>
    <router-view />
  </main>
  <AppFooter />
</template>